package gr.tech.models.skus

import gr.tech.util.isValidInput
import gr.tech.util.validateCurrencyInput
import kotlinx.serialization.Serializable

const val AMOUNT_PER_RECEIPT_DEFAULT = 2

@Serializable
data class SkuDTO(
    val id: Int,
    val sku: String,
    val description: String,
    val unitPrice: Long,
    var amountPerReceipt: Int?,
    var createdAt: String,
    var createdBy: String,
    var updatedAt: String,
    var status: Short
) {
    fun isValid(): Boolean {
        return sku.isNotBlank() && sku.isValidInput(3, 128) &&
                unitPrice.validateCurrencyInput(min = 100).isBlank()
    }
}

val blankSKUDTO = SkuDTO(
    id = -1,
    sku = "",
    description = "",
    unitPrice = 0,
    amountPerReceipt = AMOUNT_PER_RECEIPT_DEFAULT,
    createdAt = "",
    createdBy = "",
    updatedAt = "",
    status = SKU_STATUS.ACTIVE.bit
)
    